import { makeRootStyles } from "../theme/styles";

const useStyles = makeRootStyles(
  {
    shipmentWrapper: {
      display: "flex",
      alignItems: "center",
      flexDirection: "column",
      gap: "1rem",
      width: "100%",
      textAlign: "center",
    },
    shipmentHeader: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "0.5rem",
    },
    shipmentActionsWrapper: {
      margin: 0,
      padding: 0,
      display: "flex",
      justifyContent: "center",
      flexWrap: "wrap",
      listStyle: "none",
    },
    shipmentAction: {
      margin: 0,
      "@media screen and (max-width: 768px)": {
        width: "100%",
        margin: "0.25rem auto",
      },
      "&::before": {
        content: "'•'",
        fontSize: "0.5rem",
        margin: "0 0.5rem",
        "@media screen and (max-width: 768px)": {
          content: "''",
          margin: 0,
        },
      },
      "&:first-child::before": {
        content: "''",
        margin: 0,
      },
    },
    shipmentItems: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "0.5rem",
      width: "100%",
    },
    spinnerContainer: {
      margin: "0 0.5rem",
    },
  },
  {
    name: "ItemSelectorRaw",
  },
);

export { useStyles };
